import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function createFloorPlan(data) {
    return HttpService.post('/v1/floor-plans/', data);
}

export async function updateFloorPlan(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/floor-plans/' + id, data);
}

export async function removeFloorPlan(id) {
    return HttpService.delete('/v1/floor-plans/' + id).then(() => id);
}

export async function loadFloorPlans(projectId) {
    return HttpService.get('/v1/floor-plans', { projectId });
}

// FLOORS

export async function loadFloors(floorPlanId) {
    return HttpService.get('/v1/floor-plans/floors', { floorPlanId });
}

export async function createFloor(data) {
    return HttpService.post('/v1/floor-plans/floors', data);
}

export async function updateFloor(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/floor-plans/floors/' + id, data);
}

export async function removeFloor(id) {
    return HttpService.delete('/v1/floor-plans/floors/' + id).then(() => id);
}

// ROOMS

export async function createRoom(data) {
    return HttpService.post('/v1/floor-plans/rooms', data);
}

export async function updateRoom(data) {
    const { id } = data;
    delete data.id;
    delete data.floorId;
    return HttpService.put('/v1/floor-plans/rooms/' + id, data);
}

export async function removeRoom(id) {
    return HttpService.delete('/v1/floor-plans/rooms/' + id).then(() => id);
}
